import { Link } from "react-router-dom";
import { ArrowRight, PenLine } from "lucide-react";
import PageHeader from "@/components/PageHeader";
import { Reveal, FadeIn } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

export default function CommunityStories() {
    return (
        <>
            <PageHeader
                eyebrow="Real voices, real neighborhoods"
                title="Community Stories"
                description="Local events, neighborhood highlights, organizations, and stories that connect people across the Twin Cities."
            />

            <section className="pb-24 sm:pb-32">
                <div className="mx-auto max-w-7xl px-5 sm:px-8">
                    <Reveal>
                        <div
                            data-testid="community-stories-coming-soon-card"
                            className="grain relative overflow-hidden border border-white/10 bg-coal/60 px-6 py-16 text-center sm:px-12 sm:py-24"
                        >
                            <img
                                src={IMAGES.bentoCommunity}
                                alt=""
                                aria-hidden="true"
                                className="absolute inset-0 h-full w-full object-cover opacity-15"
                            />
                            <div className="absolute inset-0 bg-gradient-to-b from-ink/70 via-ink/85 to-ink" />
                            <div className="relative z-10 mx-auto max-w-2xl">
                                <FadeIn delay={0.1}>
                                    <PenLine
                                        size={40}
                                        className="mx-auto text-neon-pink"
                                        style={{
                                            filter:
                                                "drop-shadow(0 0 10px rgba(255,0,127,0.7))",
                                        }}
                                    />
                                </FadeIn>
                                <FadeIn delay={0.25}>
                                    <p className="mt-6 font-script text-4xl text-neon-pink neon-pink-text animate-flicker sm:text-5xl">
                                        stories are being crafted...
                                    </p>
                                </FadeIn>
                                <FadeIn delay={0.35}>
                                    <h2 className="mt-6 font-display text-2xl font-bold uppercase sm:text-4xl">
                                        Stories from Minneapolis &amp; St. Paul
                                        are on the way
                                    </h2>
                                </FadeIn>
                                <FadeIn delay={0.45}>
                                    <p className="mt-5 text-fog sm:text-lg">
                                        We're out in the neighborhoods
                                        gathering the highlights — the openings,
                                        the organizations, the everyday
                                        neighbors doing extraordinary things.
                                        Know one? Send it our way.
                                    </p>
                                </FadeIn>
                                <FadeIn delay={0.55}>
                                    <div className="mt-9 flex flex-wrap justify-center gap-4">
                                        <Link
                                            to="/contact?type=Story%20idea"
                                            data-testid="stories-submit-btn"
                                            className="group flex items-center gap-2 rounded-full bg-neon-pink px-7 py-3 text-[13px] font-semibold uppercase tracking-[0.14em] text-ink transition-all hover:neon-box-pink"
                                        >
                                            Submit a story idea
                                            <ArrowRight
                                                size={15}
                                                className="transition-transform group-hover:translate-x-1"
                                            />
                                        </Link>
                                        <Link
                                            to="/contact?type=Event%20coverage"
                                            data-testid="stories-coverage-btn"
                                            className="rounded-full border border-white/20 px-7 py-3 text-[13px] font-semibold uppercase tracking-[0.14em] text-silver transition-all hover:border-neon-pink hover:text-neon-pink"
                                        >
                                            Request event coverage
                                        </Link>
                                    </div>
                                </FadeIn>
                            </div>
                        </div>
                    </Reveal>
                </div>
            </section>

            <section className="border-t border-white/10 bg-coal/40 py-16">
                <div className="mx-auto max-w-7xl px-5 sm:px-8">
                    <Reveal>
                        <p className="eyebrow">What you'll find here</p>
                        <ul className="mt-8 grid gap-px overflow-hidden border border-white/10 sm:grid-cols-4" data-testid="stories-topics-strip">
                            {[
                                "Local events",
                                "Neighborhood highlights",
                                "Organizations",
                                "People across the Twin Cities",
                            ].map((v) => (
                                <li
                                    key={v}
                                    className="flex items-center justify-center bg-ink px-4 py-8 text-center font-mono text-[11px] uppercase tracking-[0.2em] text-silver transition-colors hover:text-neon-pink"
                                >
                                    {v}
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>
            </section>
        </>
    );
}
